import { Modal } from "antd";
import { setMe, useSelectAuthUser } from "features/authUserSlice";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { getMe } from "services/auth";

const ignorePath = ["/sign-in"];

const CheckAuth = () => {
  const { accessToken } = useSelector(useSelectAuthUser);
  const dispatch = useDispatch();

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await getMe();
      dispatch(setMe({ user: data }));
    } catch (error: any) {
      Modal.error({
        content: error.response.data.message,
      });
    }
  }, [dispatch]);

  useEffect(() => {
    if (accessToken) fetchMe();
  }, [fetchMe, accessToken]);

  if (!accessToken && !ignorePath.includes(window.location.pathname))
    return <Navigate to={"/sign-in"} />;

  return <Outlet />;
};

export default CheckAuth;
